//noScroll
class HumMenu {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const navBtn = document.querySelector('.nav-btn')
    const navBtnTxt = document.querySelector('.nav-btn-txt')
    const HeaderReserve = document.querySelector('.header-reserve')
    const navMenu = document.querySelector('.navMenu')
    const Header = document.querySelector('.js-header ')
    const overLay = document.querySelector('.bg-overlay')
    const body = document.querySelector('body')

    navBtn.addEventListener('click', () => {
      navBtn.classList.toggle('is-active')
      navBtnTxt.classList.toggle('is-active')
      Header.classList.toggle('is-active')
      HeaderReserve.classList.toggle('is-active')
      navMenu.classList.toggle('is-active')
      overLay.classList.toggle('is-active')
      body.classList.toggle('no-scroll')
    });

    overLay.addEventListener('click', () => {
      navBtn.classList.remove('is-active')
      navBtnTxt.classList.remove('is-active')
      Header.classList.remove('is-active')
      HeaderReserve.classList.remove('is-active')
      navMenu.classList.remove('is-active')
      overLay.classList.remove('is-active')
      body.classList.remove('no-scroll')
    });
  }
}
